// ホーム画面へ追加を誘導するポップアップ
// ログイン済みユーザーにのみ表示される（ERBテンプレート側で制御）

import { Controller } from '@hotwired/stimulus'
import { Modal } from 'bootstrap'

export default class extends Controller {
  static values = {
    guideViewed: Boolean,
    apiEndpoint: String,
  }

  declare guideViewedValue: boolean
  declare apiEndpointValue: string

  connect() {
    const isMobile = window.matchMedia('(max-width: 768px)').matches

    // SP かつ未表示の場合にモーダルを表示
    if (isMobile && !this.guideViewedValue) {
      const modalElement = document.getElementById('infoAddHomeBookmarkModal')
      if (modalElement) {
        const modal = new Modal(modalElement)
        modal.show()
      }
    }
  }

  async toggleViewed(event: Event) {
    const target = event.target as HTMLInputElement
    const viewed = target.checked

    try {
      const csrfToken =
        document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''
      const response = await fetch(this.apiEndpointValue, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken,
        },
        body: JSON.stringify({ home_screen_guide_viewed: viewed }),
      })

      if (!response.ok) {
        target.checked = !viewed
        console.error('Failed to update home screen guide setting')
      }
    } catch (error) {
      target.checked = !viewed
      console.error('Network error:', error)
    }
  }
}
